import React from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { Flex, Group, Stack, Text } from '@mantine/core';
import Button from '../../components/elements/Button';

interface ModalDownloadProps {
  opened: boolean;
  title: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalDownload: React.FC<ModalDownloadProps> = ({
  opened,
  title,
  onClose,
  onConfirm
}) => {
  return (
    <ModalWrapper title={title} isVisible={opened} onClose={onClose}>
      <Stack>
        <Text>Are you sure to download the data of {title}?</Text>
        <Group justify="space-between" gap={16}>
          <Flex flex={1}>
            <Button full onClick={() => onConfirm()}>
              Download Data
            </Button>
          </Flex>
        </Group>
      </Stack>
    </ModalWrapper>
  );
};

export default ModalDownload;
